module.exports = __webpack_public_path__ + "img/golfstrim.d71fc29c.png";